import React from "react";
import styled from "styled-components";
import { FiPhoneCall, FiMail } from "react-icons/fi";
import { RiDoubleQuotesL, RiDoubleQuotesR } from "react-icons/ri";

const ContactForm = () => {
  return (
    <ContactContianer>
      <ContactGrid>
        <ContactCard>
          <h2>Contact Us</h2>
          <p>
            <RiDoubleQuotesL /> Our team is gracefully waiting for your queries
            & responce of Money Manger software please fill the contact form we
            will revert you back <RiDoubleQuotesR />
          </p>
          <ul>
            <li>
              <div>
                <FiPhoneCall className="check" />
              </div>
              +91 8888830536
            </li>
            <li>
              <div>
                <FiMail className="check" />
              </div>
              admin@moneymanagerindia.in
            </li>
          </ul>
        </ContactCard>
        <ContactCard>
          <div className="grid">
            <div>
              <label>Full Name*</label>
              <input type="text" placeholder="Enter full name" />
            </div>
            <div>
              <label>Email*</label>
              <input type="text" placeholder="Enter your email" />
            </div>
          </div>
          <div className="grid">
            <div>
              <label>Phone No*</label>
              <input type="text" placeholder="Enter your phone no" />
            </div>
            <div>
              <label>Company Name (optional)</label>
              <input type="text" placeholder="Enter your company name" />
            </div>
          </div>
          <div className="flex">
            <label>Subject*</label>
            <input type="text" placeholder="Enter your subject" />
          </div>
          <div className="flex">
            <label>Message*</label>
            <textarea
              name=""
              id=""
              cols="30"
              rows="10"
              placeholder="Enter your message"
            ></textarea>
          </div>
          <div className="submit">Submit</div>
        </ContactCard>
      </ContactGrid>
    </ContactContianer>
  );
};

export default ContactForm;

const ContactContianer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem calc((100vw - 1200px) / 2);
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 2rem;

  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    margin: 15px;
  }
`;

const ContactCard = styled.div`
  h2 {
    font-size: 45px;
    font-weight: 500;
    color: #20204f;
  }
  p {
    font-weight: 400;
    font-size: 23px;
    color: #20204f;
  }
  ul {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    margin-top: 20px;
    list-style: none;
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #015a01;
      margin: 0px 0px;
      font-size: 20px;
      font-weight: 400;
      display: flex;
      margin-bottom: 15px;

      div {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #9eff9e;
        height: 50px;
        width: 50px;
        border-radius: 50%;
        margin-right: 7px;

        .check {
          font-size: 22px;
          color: green;
        }
      }
    }
  }
  label {
    color: #20204f;
    font-weight: 500;
    font-size: 15px;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
    margin-bottom: 15px;

    input {
      width: 330px;
      padding: 15px 15px;
      border: none;
      outline: none;
      border-radius: 7px;
      margin-top: 3px;
      color: #20204f;
      font-size: 16px;

      &::placeholder {
        font-size: 15px;
        color: lightgray;
      }
    }
  }
  .flex {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
    input {
      width: 100%;
      padding: 15px 15px;
      border: none;
      outline: none;
      border-radius: 7px;
      margin-top: 3px;
      color: #20204f;
      font-size: 16px;

      &::placeholder {
        font-size: 15px;
        color: lightgray;
      }
    }
    textarea {
      height: 115px;
      padding: 15px 15px;
      border: none;
      outline: none;
      border-radius: 7px;
      margin-top: 3px;
      color: #20204f;
      font-size: 16px;

      &::placeholder {
        font-size: 15px;
        color: lightgray;
      }
    }
  }
  .submit {
    cursor: pointer;
    padding: 6px 15px;
    color: #20204f;
    background-color: #aee4fd;
    border: 3px solid #20204f;
    font-size: 20px;
    border-radius: 7px;
    width: 20%;
    text-align: center;
  }

  @media only screen and (max-width: 991px) {
    h2 {
      font-size: 40px;
      font-weight: 500;
      color: #20204f;
    }
    p {
      font-weight: 400;
      font-size: 21px;
      color: #20204f;
    }
    .grid {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 1rem;
      margin-bottom: 15px;

      input {
        width: 100%;
        padding: 15px 15px;
        border: none;
        outline: none;
        border-radius: 7px;
        margin-top: 3px;
        color: #20204f;
        font-size: 16px;

        &::placeholder {
          font-size: 15px;
          color: lightgray;
        }
      }
    }
    .submit {
      cursor: pointer;
      padding: 6px 15px;
      color: #20204f;
      background-color: #aee4fd;
      border: 3px solid #20204f;
      font-size: 20px;
      border-radius: 7px;
      width: 40%;
      text-align: center;
    }
  }
`;
